import React, { Component } from 'react'
import { connect } from 'react-redux'

import { getTimezone} from 'utils/date'

import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card'
import MenuItem from 'material-ui/MenuItem'
import Divider from 'material-ui/Divider'
import SelectField from 'material-ui/SelectField'
import Badge from 'material-ui/Badge'

import { doc, dirtyRead } from 'selectors/common'
import { propertyEvents } from 'selectors/events'

import Section from 'components/Section'
import dataActions from 'actions/dataActions'
import sectionsActions from 'actions/sections'
import AddButton from 'components/Comments/AddButton'
import EventList from './List'

const filters = ["EVENTS", "Repairs"]

let select = dirtyRead(
	(state, props) => ({
		property: doc(state, props.propertyID)
	  , expanded: state.sections["property/events"] !== undefined ? state.sections["property/events"] : true
	})
)

export class Events extends Component{
	state = {
		tabSelected: "EVENTS"
	}
	selectFilter = (filter) => {
		this.setState({
			tabSelected: filter
		})
	}
	render(){
		let { props } = this
		let tabSelected=this.state.tabSelected
		/*let commentQuery = props.commentQuery || (location.search.indexOf("comment") == -1? false : true)
		if (commentQuery && tabSelected!="Comments") {
			tabSelected="Comments"
			history.pushState(null, null, '/landlord/property/'+props.propertyID)
		}*/
		return(
			<div className="Section" style={{marginBottom: props.expanded?"10px":"0", marginTop:props.expanded && !props.top?"10px":"0"}}>
				<Divider style={{margin: "0"}}/>
				<Card
					style={{
						boxShadow:props.expanded?"0px 2px 1px rgba(0,0,0,0.3)":"0px 1px 1px rgba(0,0,0,0.3)"
					}}
					expanded={props.needBeExpanded || props.expanded}
					onExpandChange={(expanded)=> props.SECTION_EXPAND({section: "property/events", expanded:props.alwaysExpanded || expanded})}
				>
					<CardHeader
						titleStyle={{padding:"0"}}
						title={
							<div style={{paddingLeft:"20px"}}>
								<span style={{float: "left", fontWeight: "bold", fontSize: "16px", lineHeight:"54px"}}>EVENTS</span>
								{/*<div
								  style={{display:"inline-block", position:"relative", top:"-45px", left:"-250px"}}
								>
									<div
							          className="notify-holder"
							        >
							  	        <div
							  	          className={`notify-icon-holder }`}
							  	          onClick={()=>{this.selectFilter("Inbox")}}
							  	        >
							  				{(props.messages && R.filter((x)=>(!x.done && !x.read), props.messages).length>0) &&
							  					<Badge
							  						badgeContent={R.filter((x)=>(!x.done && !x.read), props.messages).length}
							  						secondary={true}
							  						badgeStyle={{top: '-15px', right: '-12px'}}
							  						style={{
							  							padding: ''
							  						}}
							  					>
							  						<i className="material-icons" style={{color: "#5ae4c3"}}>email</i>
							  					</Badge>
							  				}
							          	</div>
							        </div>
								</div>
								<div style={{float:"right", paddingTop:"10px", marginRight:"-10px"}} onClick={()=>{this.selectFilter("Comments")}}>
									<AddButton />
								</div>*/}
							</div>
						}
						textStyle={{width: "100%"}}
						style={{padding:"0px"}}
						showExpandableButton={true}
					/>
					<CardText expandable={true} style={{marginTop:"-20px", marginBottom:"-20px"}}>
						{(tabSelected=="EVENTS" || tabSelected=="Repairs") && <EventList propertyID={props.propertyID} tabSelected={tabSelected}/>}
					</CardText>
				</Card>
			</div>
		)
	}
}

export default connect(select, sectionsActions)(Events)



// WEBPACK FOOTER //
// ./src/routes/landlord/dashboard/propertyForm/events/index.js